module.exports = __webpack_public_path__ + "img/popup.762c72f6.jpg";